export default "__VITE_ASSET__1cc40d6c__"